module.exports = __webpack_public_path__ + "img/arrow.250a0c14.svg";